import type { ReactNode } from "react";

import { cn } from "../../lib/utils";
import SkeletonTextLine from "../skeleton/SkeletonTextLine";

type SectionTitleProps = {
  title: ReactNode;
  className?: string;
};

function SectionTitle({
  title,
  className,
}: SectionTitleProps): React.JSX.Element {
  return (
    <div
      className={cn(
        "inline-flex w-fit items-center justify-center rounded-lg px-2 py-1 bg-ds-secondary",
        className
      )}
    >
      <h2 className="m-0 font-dm-sans text-publication-lg font-bold tracking-tight text-ds-primary">
        {title}
      </h2>
    </div>
  );
}

/**
 * Loading silhouette for {@link SectionTitle}: the same filled badge shell
 * (bg-ds-secondary, rounded-lg, px-2 py-1) with a text line standing in for the
 * title. `publication-lg` is 19/26, giving the badge its real ~34px height.
 */
function SectionTitleSkeleton({
  width,
}: {
  width: number | string;
}): React.JSX.Element {
  return (
    <div className="inline-flex w-fit items-center rounded-lg bg-ds-secondary px-2 py-1">
      <SkeletonTextLine width={width} fontSize={19} lineHeight={26} />
    </div>
  );
}

export { SectionTitle, SectionTitleSkeleton, type SectionTitleProps };
